import { rqClient } from "@/shared/api/instance";
import { useSession } from "@/shared/model/session";

export function useTicketsUnreadCount() {
  const { isAuthenticated } = useSession();

  const { data } = rqClient.useQuery(
    "get",
    "/api/v1/tickets/unread_count",
    {},
    {
      refetchInterval: 60000, // Refetch every minute
      enabled: isAuthenticated,
    },
  );

  return data?.unread_count ?? 0;
}
